import { render, staticRenderFns } from "./SubsList.vue?vue&type=template&id=07482ea5&"
import script from "./SubsList.vue?vue&type=script&lang=js&"
export * from "./SubsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports